/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MASKED_NUMBER_PHONE_LENGTH } from '../../utilities/constants';
import { handleFormBlur } from '../../utilities/formsUtils';
import { removeWhitespaces } from '../../utilities/helpers';

const ConfirmPhoneNumber = ({ timer, form, user, isPhone, onSubmit, setForm }) => {
  const { t: translate } = useTranslation();

  const handleChange = (e, fieldName) => {
    if (!e) return;
    if (!e.target) {
      setForm({ ...form, [fieldName]: e });
    } else {
      const { name, value } = e.target;
      setForm({ ...form, [name]: value });
    }
  };

  const clearError = (e) => {
    e.target.className = e.target.className.replace('has-error', '');
  };

  const getMaskedPhoneNumber = () => {
    let phoneNumber = form.confirmed_phone_number;
    let countryCode = user.country_code;
    let maskedPhoneNumber = '';
    if (phoneNumber.indexOf('*') !== -1) {
      maskedPhoneNumber = phoneNumber;
    } else {
      countryCode = countryCode.replace('+', '');
      phoneNumber = phoneNumber.replace('+', '');

      const cutPhoneNumberFrom = countryCode.length + MASKED_NUMBER_PHONE_LENGTH;
      phoneNumber = removeWhitespaces(phoneNumber);
      maskedPhoneNumber = `+${countryCode}${'*'.repeat(
        MASKED_NUMBER_PHONE_LENGTH
      )}${phoneNumber.substr(cutPhoneNumberFrom, phoneNumber.length - 1)}`;
    }
    return maskedPhoneNumber;
  };

  return (
    <form onSubmit={onSubmit} id="confirm-phone-form">
      <div className="form-group">
        {isPhone && (
          <input
            readOnly
            name="confirmed_phone_number"
            onChange={handleChange}
            onBlur={handleFormBlur}
            onFocus={clearError}
            value={getMaskedPhoneNumber}
            type="tel"
            className="form-control-input"
            placeholder={translate('phone_number_input_label')}
            required
          />
        )}
        {isPhone && (
          <label className="floating-label">{translate('phone_number_input_label')}</label>
        )}
      </div>
      <div className="form-group">
        <input
          type="number"
          className="form-control-input"
          placeholder={translate('confirm_phone_number_code_label')}
          onChange={handleChange}
          onBlur={handleFormBlur}
          onFocus={clearError}
          name="code"
          value={form?.code}
          autoComplete="off"
          required
        />
        <label className="floating-label">{translate('confirm_phone_number_code_label')}</label>
        <label className="error-label">{translate('verification_code_error_label')}</label>
        <label className="text-f6 w-95 mt-2 text-shadow">
          {translate('confirm_phone_number_message_label_nosec').replace(
            '%s',
            getMaskedPhoneNumber
          )}
          <span>
            {timer}
            {translate('email_verification_subtext_label_sec')}
          </span>
        </label>
      </div>
    </form>
  );
};

export default ConfirmPhoneNumber;

ConfirmPhoneNumber.propTypes = {
  user: PropTypes.object.isRequired,
  isPhone: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  timer: PropTypes.number.isRequired,
};
